import { requests, mainApiRoot } from './index'

export const SeoChecklist = {
  getAll: domainId => requests.get(mainApiRoot, `/domains/${domainId}/seo-strategy`),
  update: (domainId, payload) =>
    requests.put(mainApiRoot, `/domains/${domainId}/seo-strategy`, payload),
  getDomains: () => requests.get(mainApiRoot, '/seo-strategies')
}
